import { Link, useLocation } from 'react-router-dom';
import { localizePath, selectedLanguage } from '../languages';
import { tr } from '../i18n';

export function NotFoundPage() {
  const language = selectedLanguage(useLocation().pathname).code;
  const to = (path: string) => localizePath(path, language);
  return <main className="not-found-page">
    <section className="shell not-found-content" aria-labelledby="not-found-title">
      <div className="not-found-art" aria-hidden="true"><span>4</span><span className="not-found-record"/><span>4</span></div>
      <p className="not-found-eyebrow">404 · Suno Download</p>
      <h1 id="not-found-title">Page not found</h1>
      <p className="not-found-description">This link may be outdated or incomplete. Try the homepage, tools, or guides.</p>
      <Link className="not-found-home" to={to('/')}><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" aria-hidden="true"><path d="m14 6-6 6 6 6M8 12h12"/></svg>{tr('Back to home')}</Link>
      <nav className="not-found-links" aria-label={tr('Explore')}><Link to={to('/tools/')}>{tr('Tools')} <span aria-hidden="true">↗</span></Link><Link to={to('/articles/')}>{tr('Articles')} <span aria-hidden="true">↗</span></Link><Link to={to('/about/')}>{tr('About Us')} <span aria-hidden="true">↗</span></Link></nav>
    </section>
  </main>;
}
